import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader";

const $productJourneyBlock = $( '.product-journey' );

if ( $productJourneyBlock.length ) {
	const $popupWrapper = $( '.suppliers-map-popup__wrapper' ),
			$popup = $( '.suppliers-map-popup' );

	const gmapsLoader = new Loader( {
		apiKey: superunie.google_maps_api_key,
		version: 'weekly',
	} );

	gmapsLoader.load().then( () => {
		const mapContainer = document.getElementById( 'product-journey-map' );

		if ( !mapContainer ) {
			return;
		}

		const map = new google.maps.Map( mapContainer );

		// Markers
		if ( typeof journeyLocations !== 'undefined' && journeyLocations.length > 0 ) {
			const bounds = new google.maps.LatLngBounds();

			journeyLocations.forEach( function ( item ) {
				let locationMarkerImage = null;

				if ( item.icon ) {
					locationMarkerImage = new google.maps.MarkerImage( item.icon,
							new google.maps.Size( 50, 50 ),
							new google.maps.Point( 0, 0 ),
							new google.maps.Point( 25, 25 ) );
				}

				const itemLocation = { lat: item.lat, lng: item.lng };

				const locationMarker = new google.maps.Marker( {
					position: itemLocation,
					...( locationMarkerImage && { icon: locationMarkerImage } ),
					map,
				} );

				locationMarker.addListener( 'click', () => {
					const template = wp.template( 'suppliers-map-popup' );

					const data = {
						title: item.title,
						introImage: item.intro_image,
						introText: item.intro_text,
						supplierName: item.supplier_name,
						supplierAddress: item.supplier_address,
						supplierPostalCode: item.supplier_postalcode,
						supplierCity: item.supplier_city,
						supplierCountry: item.supplier_country,
						supplierUrl: item.supplier_url,
					};

					$popup.html( template( data ) );

					$popupWrapper.show();
				} );

				bounds.extend( locationMarker.position );
			} );

			map.fitBounds( bounds );
		}

		// Polylines
		if ( typeof journeyConnections !== 'undefined' && journeyConnections.length > 0 ) {
			journeyConnections.forEach( function ( item ) {
				const lineSymbol = {
					path: "M 0,1 0,0",
					strokeOpacity: 1,
					strokeWeight: 2,
					scale: 1
				};

				let locations = item.map( function ( obj ) {
					return {
						lat: obj.lat,
						lng: obj.lng
					};
				} );

				const productJourney = new google.maps.Polyline( {
					path: locations,
					geodesic: true,
					strokeColor: "#D0021B",
					strokeOpacity: 0,
					icons: [
						{
							icon: lineSymbol,
							offset: "0",
							repeat: "6px",
						},
					],
				} );

				productJourney.setMap( map );
			} );
		}
	} );

	$productJourneyBlock.on( 'click', '.single__close-btn', function ( e ) {
		e.preventDefault();

		$popupWrapper.hide();

		return false;
	} );
}
